module.exports = "<sq-worksheet-page class=\"worksheetColumn flexColumnContainer flexFill\"></sq-worksheet-page>\n";